<!-- Gráficos en tarjetas del detalle, de a dos. Los que necesitan ancho
     (estado de TX, airtime, RSSI) van a lo ancho. -->
<div class="graficos">
  <app-dt-card titulo="Paquetes recibidos (15 días)">
    <app-chart-card
      class="grafico"
      [chartOptions]="chartPaquetesRecibidos"
      [showShadow]="false"
    ></app-chart-card>
  </app-dt-card>

  <app-dt-card titulo="Paquetes transmitidos (15 días)">
    <app-chart-card
      class="grafico"
      [chartOptions]="chartPaquetesTransmitidos"
      [showShadow]="false"
    ></app-chart-card>
  </app-dt-card>

  @if (chartHistorialStats) {
    <app-dt-card
      class="ancha"
      titulo="Envío de stats (% recibidos vs. esperados, últimas 24 h)"
    >
      <app-chart-card
        class="grafico"
        [chartOptions]="chartHistorialStats"
        [showShadow]="false"
      ></app-chart-card>
    </app-dt-card>
  }

  <app-dt-card titulo="Recibidos por frecuencia">
    <app-chart-card
      class="grafico"
      [chartOptions]="chartHeatmapRxFreqData"
      [showShadow]="false"
    ></app-chart-card>
  </app-dt-card>

  <app-dt-card titulo="Transmitidos por frecuencia">
    <app-chart-card
      class="grafico"
      [chartOptions]="chartHeatmapTxFreqData"
      [showShadow]="false"
    ></app-chart-card>
  </app-dt-card>

  <app-dt-card titulo="Recibidos por data rate">
    <app-chart-card
      class="grafico"
      [chartOptions]="chartHeatmapRxDrData"
      [showShadow]="false"
    ></app-chart-card>
  </app-dt-card>

  <app-dt-card titulo="Transmitidos por data rate">
    <app-chart-card
      class="grafico"
      [chartOptions]="chartHeatmapTxDrData"
      [showShadow]="false"
    ></app-chart-card>
  </app-dt-card>

  <app-dt-card class="ancha" titulo="Transmitidos por estado">
    <app-chart-card
      class="grafico"
      [chartOptions]="chartTxStatus"
      [showShadow]="false"
    ></app-chart-card>
  </app-dt-card>

  <app-dt-card
    class="ancha"
    titulo="Ocupación de tiempo de aire por canal (últimas 24 h)"
  >
    <app-chart-card
      class="grafico"
      [chartOptions]="chartAirtimeHeatmap"
      [showShadow]="false"
    ></app-chart-card>
  </app-dt-card>

  <app-dt-card class="ancha" titulo="Uplinks por RSSI (últimas 6 h)">
    <app-chart-card
      class="grafico"
      [chartOptions]="chartScatterUplinks"
      [showShadow]="false"
      chartHeight="400px"
      [sinDatos]="
        uplinksCargados && !chartScatterUplinks
          ? 'Sin uplinks en las últimas 6 h'
          : null
      "
    ></app-chart-card>
  </app-dt-card>
</div>
